import { Enumerable, Kbo } from "@models/configurators/configurator-di";
import { CToken } from "@models/configurators/ctoken";
import { KbObjectManager } from "@models/configurators/kb-object-manager";
import { Tab } from "@models/configurators/tab";
import { UiObject } from "@models/configurators/ui-object";
import { ITabControl } from "@models/entity-models";

@Kbo(CToken.TabControl)
export class TabControl extends UiObject implements ITabControl {

    constructor(kom: KbObjectManager) {
        super(kom);
    }

    public tabWidth: string;
    public customTabWidth: number;
    public $selectedTab: string;

    private _tabs: Tab[];
    @Enumerable()
    public get tabs(): Tab[] {
        if (!this._tabs) this._tabs = [];
        return this._tabs;
    }
    public set tabs(val) {
        this._tabs = val;
    }

    public getChildrenOfType<T extends UiObject>(...tokens: CToken[]): T[] {
        return this.filterChildren<T>(tokens,
            this.tabs
        );
    }

    public allowedChildren(rootType: CToken): CToken[] {
        return [
            CToken.Tab
        ];
    }
}
